<template>
  <b-modal
    id="ingresarPagoVirtual"
    ref="modal"
    title="Ingresar Pago Virtual"
    size="xl"
    hide-footer
    @shown="onModalShown"
  >
    <div class="card">
      <form
        @submit.prevent="submit"
        ref="form"
        v-promise-btn="{ action: 'submit' }"
      >
        <div class="container">
          <div class="row">
            <div class="col-12 col-md-6 form-group form-group-sm">
              <div class="form-group" v-if="periodo">
                <label for="periodo" class="label">Periodo</label>
                <input
                  disabled
                  class="form-control bg-white"
                  style="cursor: text"
                  type="month"
                  id="periodo"
                  name="periodo"
                  v-model="periodo"
                />
              </div>
            </div>
            <div class="col-12 col-md-6 form-group form-group-sm">
              <label for="fecha_aviso" class="label">Fecha de compromiso</label>
              <input
                class="form-control"
                type="datetime-local"
                id="fecha_aviso"
                name="fecha_aviso"
                v-model="fechaCompromiso"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 form-group form-group-sm">
              <label class="label" for="montoAPagar">Monto a pagar</label>
              <vue-numeric
                id="monto_a_pagar"
                v-select-on-focus
                currency="$"
                thousand-separator="."
                decimal-separator=","
                :precision="2"
                v-model="monto_a_pagar"
                :minus="true"
                class="col-12 form-control form-control-sm text-center bg-white"
              ></vue-numeric>
              <div class="form-group"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <button
                  @click="$bvModal.hide('ingresarPagoVirtual')"
                  type="button"
                  class="btn btn-danger"
                >
                  Cancelar
                </button>
                <button type="submit" class="btn btn-primary">Confirmar</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </b-modal>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";
import vueNumeric from "../../../../lib/utils/vue-numeric";

export default {
  name: "IngresarPagoVirtualModal",
  props: ["cliente"],
  components: { vueNumeric },
  data: () => ({
    monto_a_pagar: 0,
    fechaCompromiso: null,
  }),
  methods: {
    async submit() {
      if (!this.monto_a_pagar) {
        this.$msgBoxOk("Por favor, ingrese un monto");
        return;
      }
      const resp = await axios.post("/execute", {
        method: "CLI.IngresaPagoVirtual",
        parameters: [
          { name: "id_ticket", value: this.$route.params.id_ticket },
          { name: "monto_a_pagar", value: this.monto_a_pagar },
          {
            name: "fecha_compromiso_pago",
            value: this.$moment(this.fechaCompromiso).format(
              "YYYY-MM-DD HH:mm",
            ),
          },
        ],
      });

      if (get(resp, "data.ok", false)) {
        await this.$store.dispatch("Suspensiones/getDeudores");
        this.$bvModal.hide("ingresarPagoVirtual");
        this.$emit("update");
        this.$msgBoxOk("Éxito!");
      } else {
        this.$msgBoxOk(get(resp, "data.message", "Ha ocurrido un error"));
      }
    },
    onModalShown() {
      this.monto_a_pagar = 0;
      this.initFechaCompromiso();
    },
    initFechaCompromiso() {
      const iteracion =
        this.$store.state.Suspensiones.EvitarSuspensiones.iteracion;
      if (iteracion && iteracion[0] && iteracion[0].fecha_compromiso) {
        this.fechaCompromiso = this.$moment(
          iteracion[0].fecha_compromiso,
        ).format("YYYY-MM-DD HH:mm");
      } else {
        this.fechaCompromiso = this.$moment().format("YYYY-MM-DD HH:mm");
      }
    },
  },
  computed: {
    periodo: {
      get() {
        return this.$moment().format("YYYY-MM");
      },
    },
  },
};
</script>

<style scoped></style>
